// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"4a5198ed","844":"3cde34cd"}[chunkId] + ".chunk.css";
};